import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Spinner } from "../components/ui";

// Ruta "/portal/entrar?token=…": canjea el enlace mágico por una sesión.
export function VerifyMagicLink() {
  const [params] = useSearchParams();
  const { verifyMagicLink } = useAuth();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      setError("Enlace inválido.");
      return;
    }
    verifyMagicLink(token).catch((e) => setError((e as Error).message));
  }, [params, verifyMagicLink]);

  return (
    <div className="grid min-h-screen place-items-center bg-gradient-to-br from-brand-50 via-slate-50 to-white p-4">
      <div className="w-full max-w-md text-center">
        {error ? (
          <div className="card space-y-3 p-8">
            <div className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-rose-100 text-2xl">⚠️</div>
            <h2 className="font-bold text-slate-800">No pudimos ingresarte</h2>
            <p className="text-sm text-slate-500">{error}</p>
            <Link to="/" className="btn-primary w-full">Solicitar un nuevo enlace</Link>
          </div>
        ) : (
          <div className="card p-8">
            <Spinner label="Verificando tu enlace…" />
          </div>
        )}
      </div>
    </div>
  );
}
